import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 px-6 overflow-hidden min-h-[90vh] flex items-center" data-id="element-65">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-ice/10 rounded-full blur-[120px] pointer-events-none" data-id="element-66" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-glacier/10 rounded-full blur-[100px] pointer-events-none" data-id="element-67" />

      <div className="container mx-auto max-w-5xl relative z-10 text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-panel mb-8" data-id="element-69">
          <span className="w-2 h-2 rounded-full bg-ice animate-pulse" data-id="element-70" />
          <span className="text-xs md:text-sm font-medium text-ice-light tracking-wide uppercase" data-id="element-71">
            The Winter 2026 Engine is Live
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-white via-frost to-ice-light tracking-tight leading-[1.1] mb-8" data-id="element-72">
          Command Your Seasonal <br className="hidden md:block" data-id="element-73" />
          Campaigns with Precision
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-white/60 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-74">
          Citadelgames orchestrates cold-weather and seasonal marketing
          campaigns using real-time weather intelligence and automation. Launch
          exactly when the frost hits.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-75">
          <button className="w-full sm:w-auto group flex items-center justify-center gap-2 bg-ice hover:bg-ice-light text-navy font-semibold px-8 py-4 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(77,168,218,0.4)] hover:shadow-[0_0_30px_rgba(77,168,218,0.6)] hover:-translate-y-1" data-id="element-76">
            Launch Your First Campaign
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-77" />
          </button>
          <button className="w-full sm:w-auto group flex items-center justify-center gap-2 glass-panel hover:bg-white/10 text-white font-medium px-8 py-4 rounded-full transition-all duration-300 hover:-translate-y-1" data-id="element-78">
            <PlayIcon className="w-4 h-4 text-ice-light" data-id="element-79" />
            Watch Demo
          </button>
        </motion.div>
      </div>
    </section>;
}